export const setState = payload => ({
    type: 'SET_STATE',
    payload
})

export const showPopup = payload => ({
    type: 'SHOW_POPUP',
    payload
})

export const showSpinner = payload => ({
    type: 'SHOW_SPINNER',
    payload
})

export const showSearch = payload => ({
    type: 'SHOW_SEARCH',
    payload
})

export const setProductsTable = payload => ({
    type: 'SET_PRODUCTS_TABLE',
    payload
})

export const setCategoriesAll = payload => ({
    type: 'SET_CATEGORIES_ALL',
    payload
})

export const setOtherCategoriesAll = payload => ({
    type: 'SET_OTHER_CATEGORIES_ALL',
    payload
})

export const setUserActive = payload => ({
    type: 'SET_USER_ACTIVE',
    payload
})

export const setProductsToShow = payload => ({
    type: 'SET_PRODUCTS_TO_SHOW',
    payload
})

export const setProductsChild = payload => ({
    type: 'SET_PRODUCTS_CHILD',
    payload
})

export const setProductsCategory = payload => ({
    type: 'SET_PRODUCTS_CATEGORY',
    payload
})

export const setAllProducts = payload => ({
    type: 'SET_ALL_PRODUCTS',
    payload
})

export const setAllColors = payload => ({
    type: 'SET_ALL_COLORS',
    payload
})

export const setZones = payload => ({
    type: 'SET_ZONES',
    payload
})

export const setSelectedCategory = payload => ({
    type: 'SET_SELECTED_CATEGORY',
    payload
})

export const setSelectedProductosListRouteOrigin = payload => ({
    type: 'SET_SELECTED_PRODUCTS_LIST_ROUTE_ORIGIN',
    payload
})

export const setSelectedCategoryName = payload => ({
    type: 'SET_SELECTED_CATEGORY_NAME',
    payload
})

export const setSelectedCollection = payload => ({
    type: 'SET_SELECTED_COLLECTION',
    payload
})

export const setSelectedForma = payload => ({
    type: 'SET_SELECTED_FORMA',
    payload
})

export const setSelectedHole = payload => ({
    type: 'SET_SELECTED_HOLE',
    payload
})

export const setSelectedNew = payload => ({
    type: 'SET_SELECTED_NEW',
    payload
})

export const setSelectedCharacteristic = payload => ({
    type: 'SET_SELECTED_CHARACTERISTIC',
    payload
})

// export const setFormas = payload => ({
//     type: 'SET_FORMAS',
//     payload
// })

// export const setCharacteristic = payload => ({
//     type: 'SET_CHARACTERISTIC',
//     payload
// })

// export const setHolesTypes = payload => ({
//     type: 'SET_HOLES_TYPES',
//     payload
// })

export const setSelectedColor = payload => ({
    type: 'SET_SELECTED_COLOR',
    payload
})

// export const setColors = payload => ({
//     type: 'SET_COLORS',
//     payload
// })

// export const setCollections = payload => ({
//     type: 'SET_COLLECTIONS',
//     payload
// })

export const setSelectedMinMaxDiameter = payload => ({
    type: 'SET_SELECTED_MIN_MAX_DIAMETER',
    payload
})

export const setQuantitySelected = payload => ({
    type: 'SET_QUANTITY_SELECTED',
    payload
})

export const setTotalSelected = payload => ({
    type: 'SET_TOTAL_SELECTED',
    payload
})

export const setFormatSelected = payload => ({
    type: 'SET_FORMAT_SELECTED',
    payload
})

export const setBudget = payload => ({
    type: 'PUSH_BUDGET',
    payload
})

export const setBudgetImplantacion = payload => ({
    type: 'PUSH_BUDGET_IMPLANTATION',
    payload
})

export const updateProductBudget = payload => ({
    type: 'UPDATE_PRODUCT_BUDGET',
    payload
})

export const popProductBudget = payload => ({
    type: 'POP_PRODUCT_BUDGET',
    payload
})

export const resetBudget = payload => ({
    type: 'RESET_BUDGET',
    payload
})

export const pushFilters = payload => ({
    type: 'PUSH_FILTERS',
    payload
})

export const resetFilters = payload => ({
    type: 'RESET_FILTERS',
    payload
})

export const popFilter = payload => ({
    type: 'POP_FILTER',
    payload
})

export const setPaginationState = payload => ({
    type: 'SET_PAGINATION_STATE',
    payload
})
